var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "PolarisVue-FadeUpTransition",
      "enter-active-class": "PolarisVue-FadeUpTransition--show",
      "leave-active-class": "PolarisVue-FadeUpTransition--show",
      "enter-class": "PolarisVue-FadeUpTransition--hide",
      "leave-to-class": "PolarisVue-FadeUpTransition--hide"
    }
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-76fc7556", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76fc7556","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/transitions/FadeUpTransition.vue
// module id = 369
// module chunks = 0